import type { Router, RouteRecordRaw } from 'vue-router'
import HomeView from './views/HomeView.vue'

export const MainRoutes: RouteRecordRaw = {
  path: '/',
  name: 'home',
  component: HomeView,
  redirect: '/branch',
  children: [],
  meta: {
    requiresAuth: true,
    layout: 'Default',
    title: 'dashboard',
    showBackButton: false,
  },
}

export default (router: Router) => {
  router.addRoute(MainRoutes)
}
